import { createContext, useContext } from "react"
import { ToastProps } from "@/components/Toast"

export interface ToastType {
	id: string
	role?: string
	variant?: ToastProps["variant"]
	text: string
	timing?: number
}

export interface ToastContextType {
	toasts: Array<ToastType>
	addToast(newToast: ToastType): void
	removeToast(id: ToastType["id"]): void
}

export const ToastContext = createContext<ToastContextType>(null!)

export const useToasts = () => {
	const context = useContext(ToastContext)
	if (context === null) {
		throw new Error("useToasts must be used within a ToastProvider")
	}
	return context
}
